import React from 'react'

const Language = ({ name, icon, svg }) => {
	return (
		<div className='group flex flex-col items-center gap-2 p-4 rounded-xl border border-white/8 hover:border-blue-500/40 hover:bg-blue-500/8 transition-all duration-300 cursor-default'
			style={{ background: 'rgba(255,255,255,0.03)' }}>
			{svg ? (
				<img
					src={svg}
					alt={name}
					className='w-8 h-8 opacity-60 group-hover:opacity-100 transition-opacity duration-300'
					style={{ filter: 'grayscale(100%) brightness(1.5)', transition: 'filter 0.3s, opacity 0.3s' }}
					onMouseEnter={e => e.currentTarget.style.filter = 'grayscale(0%) brightness(1)'}
					onMouseLeave={e => e.currentTarget.style.filter = 'grayscale(100%) brightness(1.5)'}
				/>
			) : (
				<i
					className={`${icon} text-3xl text-gray-400 group-hover:text-blue-400 transition-colors duration-300`}
				/>
			)}
			<span className='text-gray-500 text-xs text-center group-hover:text-gray-300 transition-colors duration-300 leading-tight'>
				{name}
			</span>
		</div>
	)
}

export default Language
